import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const ConfirmDialog = ({ open, onClose, onConfirm, t }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("mapWithComponents.deleteConfirmTitle")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("mapWithComponents.deleteConfirmDescription")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t("mapWithComponents.cancelButton")}
        </Button>
        <Button onClick={onConfirm} color="error" autoFocus>
          {t("mapWithComponents.deleteButton")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
